export default __webpack_public_path__ + "static/media/112.43b40b49.jpg";